import { actionTypes } from "./actions";
import getInitialState from "../get-initial-state";
import { helpers } from "../../common/lib";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.DATA_CHECK_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.DATA_CHECK_GET_REQUEST: {
            return getInitialState.list();
        }
        case actionTypes.DATA_CHECK_GET_SUCCESS: {
            const { dataCheck } = action.payload;
            return helpers.getListReducer(state, dataCheck);
        }
        case actionTypes.DATA_CHECK_MERGE: {
            const { dataCheck } = action.payload;
            return helpers.mergeListReducer(state, dataCheck);
        }
        case actionTypes.DATA_CHECK_POST_REQUEST: {
            const { dataCheck } = action.payload;
            return { ...state, item: dataCheck };
        }
        default: {
            return state;
        }
    }
}
